import { render, staticRenderFns } from "./NavTabs.vue?vue&type=template&id=76378fc0&scoped=true"
import script from "./NavTabs.vue?vue&type=script&lang=ts"
export * from "./NavTabs.vue?vue&type=script&lang=ts"
import style0 from "./NavTabs.vue?vue&type=style&index=0&id=76378fc0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76378fc0",
  null
  
)

export default component.exports